module.exports = __webpack_public_path__ + "static/media/cowboys-gold.545fdf3d.gif";